<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/ptSession')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.name" name="name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>PT Tier</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="pt_tier" v-validate="'required'" v-model="editData.pt_tier" :options="optTier" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('pt_tier') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Price</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.price" name="price" v-validate="'required|numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('price') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Quantity</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.quantity" name="quantity" v-validate="'required|numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('quantity') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Expired in Days</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.expired_in_days" name="expired_in_days" v-validate="'required|numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('expired_in_days') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Status</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="status" v-validate="'required'" v-model="editData.status" :options="options" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('status') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button :disabled="disableBtnSubmit" type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'

export default {
  name: 'addSession',
  data: function () {
    return {
      disableBtnSubmit: false,
      editData: {
        name: '',
        pt_tier: '',
        price: '',
        quantity: '',
        expired_in_days: '',
        status: null,
      },
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ],
      optTier: [
        { value: null, text: 'Please select' },
        { value: '1', text: 'Tier 1' },
        { value: '2', text: 'Tier 2' },
        { value: '3', text: 'Tier 3' }
      ]
    }
  },
  methods: {
    // onEditorChange(event) {
    //   console.log('onEditorChange')
    // },
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.put('fitness/v1/pt_session/'+this.$route.query.id, this.editData).then(response => {
            // console.log('test', response)
            this.$router.push('/ptSession')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    fetchData () {
      axios.get('fitness/v1/pt_session/'+ this.$route.query.id).then(response => {
        this.editData = response.data.data

        const year = moment(this.editData.created_at).format('YYYY')
        const month = moment(this.editData.created_at).format('M')
        
        axios.get('crm/v1/closing_period/member_pt_session?year='+year+'&bulan='+month).then(result => {
          this.disableBtnSubmit = true
        }).catch(error => {
          console.log('error', error)
        })

        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style lang="scss" scoped>
</style>
